import styled from "styled-components";

export const DropdownNoMatchingCellWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  min-height: 48rem;
  gap: 14rem;

  color: var(--tag-stoke-8c, #8c8c8c);
  font-family: Inter;
  font-size: 14rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
